import ngRedux from 'ng-redux'
import { IScope } from 'angular'
import { RegisterManager } from '../../../managers/register-manager'
import { selectSalePayments } from '../../../state/slices/currentSale/currentSaleSlice'
import { RootState } from '../../../state/store'
import { Payment } from '../../../models/payment'

/**
 * Controller for the sale-payment popover.
 *
 * @class SalePaymentPopoverController
 */
export class SalePaymentPopoverController {
  public outletTimeZone: string
  public payments: Payment[] = []

  constructor(
    public close: $TSFixMe,
    registerManager: RegisterManager,
    private readonly $ngRedux: ngRedux.INgRedux,
    private readonly $scope: IScope
  ) {
    'ngInject'

    const disconnectRedux = this.$ngRedux.connect((state: RootState) => ({
      payments: selectSalePayments(state),
    }))(this)
    this.$scope.$on('$destroy', disconnectRedux)

    this.outletTimeZone = registerManager.getActiveOutlet().time_zone
  }
}
